export default "__VITE_ASSET__Ca9zuBX8__"